// removed by extract-text-webpack-plugin
module.exports = {"section":"_3MtEFmnV-x4s7KReyAujAr","personalInfoGroupItem":"_3Wn4XvADX-pmMPGsGaA3ew","emailType":"_3_6tsOaL5IDGLcu5k-U4G-","emailStatus":"_3GLlTS7_leBBXGR-tifq_t","emailVerified":"_2Klx3fw-ZoxZX8SmXxwigx","emailNotVerified":"_3vJ3d3vmgxlQhURi4Fu_1E","nameField":"rsv_yeE6qd9m54xbT3_ih"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Account/Account.scss
// module id = 1347
// module chunks = 1